import { defineComponent as V, useCssModule as F, computed as t, createBlock as l, openBlock as r, resolveDynamicComponent as v, normalizeClass as s, unref as n, withCtx as T, createElementVNode as h, createElementBlock as i, createCommentVNode as c, Fragment as w, renderList as z, toDisplayString as g } from "vue";
import _ from "../../props/size.mjs";
import q from "../../utils/mapClasses.mjs";
import $ from "./components/CdrStar100.vue.mjs";
import A from "./components/CdrStar75.vue.mjs";
import D from "./components/CdrStar50.vue.mjs";
import E from "./components/CdrStar25.vue.mjs";
import L from "./components/CdrStar00.vue.mjs";
import P from "./components/CdrStarNull.vue.mjs";
const j = {
  key: 1
}, p = "cdr-rating", Z = /* @__PURE__ */ V({
  name: "CdrRating",
  components: {
    CdrStar100: $,
    CdrStar75: A,
    CdrStar50: D,
    CdrStar25: E,
    CdrStar00: L,
    CdrStarNull: P
  },
  __name: "CdrRating",
  props: {
    /**
     * Sets the rating values between 0 and 5.
     */
    rating: {
      required: !0,
      type: [String, Number],
      default: 0
    },
    /**
     * Sets the total number of ratings
     */
    count: {
      required: !1,
      type: [String, Number],
      default: null
    },
    /**
     * Hides the word 'reviews' if true
     */
    compact: {
      type: Boolean,
      default: !1
    },
    /**
     * Sets the rating component (icons and text) to display inline and wraps them in an anchor tag so they can act as link.
     */
    href: {
      type: String
    },
    /**
     * Sets the rating size.
     * @demoSelectMultiple false
     * @values small, medium, large
    */
    size: _
  },
  setup(a) {
    const e = a, o = F(), d = t(() => Number(e.rating)), k = t(() => Number(e.count)), S = t(() => e.size ? `${p}--${e.size}` : ""), N = t(() => e.href ? `${p}--linked` : ""), b = t(() => d.value > 0 || k.value > 0), x = t(() => e.href ? "a" : "div"), u = t(() => (Math.round(d.value * 10) / 10).toFixed(1)), C = t(() => Math.round(d.value * 4) / 4), y = t(() => Math.floor(C.value)), m = t(() => C.value.toFixed(2).split(".")[1]), R = t(() => 5 - y.value - (+m.value > 0 ? 1 : 0)), B = t(() => e.compact ? `(${e.count})` : `${e.count}`), M = t(() => e.href ? e.count === 0 || e.count === "0" ? "No reviews yet; be the first!" : e.count === null ? `View the reviews with an average rating of ${u.value} out of 5 stars` : `View the ${e.count} reviews with an average rating of ${u.value} out of 5 stars` : e.count === 0 || e.count === "0" ? "0 reviews" : e.count === null ? `Rated ${u.value} out of 5 stars` : `${e.count} reviews with an average rating of ${u.value} out of 5 stars`);
    return (G, H) => (r(), l(v(x.value), {
      href: a.href,
      class: s(n(q)(n(o), p, S.value, N.value))
    }, {
      default: T(() => [h("div", {
        class: s(n(o)["cdr-rating__ratings"])
      }, [(r(!0), i(w, null, z(Array(y.value).keys(), (f) => (r(), l($, {
        size: a.size,
        key: `rating-whole-${f}`,
        "aria-hidden": "true"
      }, null, 8, ["size"]))), 128)), m.value !== "00" ? (r(), l(v(`CdrStar${m.value}`), {
        key: 0,
        size: a.size,
        "aria-hidden": "true"
      }, null, 8, ["size"])) : c("", !0), (r(!0), i(w, null, z(Array(R.value).keys(), (f) => (r(), l(v(b.value ? "CdrStar00" : "CdrStarNull"), {
        size: a.size,
        key: `rating-empty-${f}`,
        "aria-hidden": "true"
      }, null, 8, ["size"]))), 128))], 2), a.count !== null ? (r(), i("span", {
        key: 0,
        "aria-hidden": "true",
        class: s(n(o)["cdr-rating__count"])
      }, [a.href ? (r(), i("span", {
        key: 0,
        class: s(n(o)["cdr-rating__number"])
      }, g(u.value), 3)) : c("", !0), h("span", null, g(B.value), 1), a.compact ? c("", !0) : (r(), i("span", j, "  Reviews "))], 2)) : c("", !0), h("span", {
        class: s(n(o)["cdr-rating__caption-sr"])
      }, g(M.value), 3)]),
      _: 1
    }, 8, ["href", "class"]));
  }
});
export {
  Z as default
};
